export const getCapabilityKeyContext = capabilityKey => capabilityKey.delete('capability').toJS();